'use client';

import React from 'react';

interface ComplianceCard {
  icon: string;
  title: string;
  subtitle: string;
}

const complianceCards: ComplianceCard[] = [
  {
    icon: '🔒',
    title: 'SOC 2 Certified',
    subtitle: 'Security & Availability',
  },
  {
    icon: '✅',
    title: 'ISO 27001',
    subtitle: 'Information Security Mgmt',
  },
  {
    icon: '🛡️',
    title: 'GDPR Compliant',
    subtitle: 'EU Data Protection',
  },
  {
    icon: '🏥',
    title: 'HIPAA Compliant',
    subtitle: 'Healthcare Data Standards',
  },
];

const EnterpriseCompliance: React.FC = () => {
  return (
    <section className="bg-white py-20 px-6 lg:px-8">
      <div className="container mx-auto">
        <div className="max-w-5xl mx-auto text-center">
          {/* Eyebrow Label */}
          <p
            className="text-xs font-semibold uppercase tracking-widest mb-4"
            style={{ color: 'var(--color-accent)' }}
          >
            Trusted by Industry Leaders
          </p>

          {/* Main Heading */}
          <h2
            className="text-3xl lg:text-4xl xl:text-5xl font-bold mb-6"
            style={{
              fontFamily: "'Titillium Web', sans-serif",
              color: '#000',
            }}
          >
            Certified, recognized, and proven at enterprise scale.
          </h2>

          {/* Description */}
          <p
            className="text-base lg:text-lg max-w-2xl mx-auto mb-14"
            style={{ color: 'var(--color-muted-foreground)' }}
          >
            UnifyMax meets the highest global security and compliance standards required by enterprise buyers.
          </p>

          {/* Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {complianceCards.map((card, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl border border-slate-100 shadow-sm hover:shadow-md hover:border-[#1bb4d7]/30 transition-all duration-300 p-8 flex flex-col items-center text-center"
              >
                {/* Icon */}
                <div
                  className="w-14 h-14 rounded-xl flex items-center justify-center text-2xl mb-5"
                  style={{ backgroundColor: 'var(--color-muted)' }}
                >
                  {card.icon}
                </div>

                {/* Title */}
                <h3
                  className="font-bold text-lg mb-2"
                  style={{ color: 'var(--color-foreground)' }}
                >
                  {card.title}
                </h3>

                {/* Subtitle */}
                <p
                  className="text-sm"
                  style={{ color: 'var(--color-muted-foreground)' }}
                >
                  {card.subtitle}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EnterpriseCompliance;
